/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useState, useLayoutEffect, useEffect } from 'react'
import ContentLoader from 'react-content-loader'
import PropTypes from 'prop-types'
import isPreRendering from 'utils/isPreRendering'
import { CountDown, Image } from 'components'
import { useFilter } from 'store/filter'
import { getCurrentBanner } from 'utils/getCurrentBanner'
import { navigate } from '@reach/router'
import {
  campaignConfigurations,
  timerFirstCampaign,
  timerSecondCampaign,
  activeCountDownToFirstCampaign,
  activeCountDownToSecondCampaign,
} from 'utils/checkCampaign'
import {
  getRandomBannerIndex,
  getSpecificBannerIndex,
  banners,
  shouldDisplay,
} from './getBannersList'
import styles from './ListBanner.module.scss'

const ListBanner = ({ filters }) => {
  const [bannerIndex, setBannerIndex] = useState('')

  const [bannerVisible, setBannerVisible] = useState(false)
  const [displayCountdownFirst, setDisplayCountdownFirst] = useState(false)
  const [displayCountdownSecond, setDisplayCountdownSecond] = useState(false)

  const {
    $filter: { currentBannerList },
    setCurrentBanner,
  } = useFilter()

  const {
    sourceNormal = '',
    sourceMobile = '',
    sourceLarge = '',
    sourceXLarge = '',
    link = '',
    campaignName = '',
  } = banners[bannerIndex] || {}

  useLayoutEffect(() => {
    if (!isPreRendering()) {
      setBannerVisible(true)
    }
    setTimeout(() => {
      setDisplayCountdownFirst(activeCountDownToFirstCampaign)
      setDisplayCountdownSecond(activeCountDownToSecondCampaign)
    }, 1500)
  }, [])

  const Placeholder = () => (
    <ContentLoader height={150}>
      <rect x="0" y={0} rx="3" ry="3" width="100%" height={150} />
    </ContentLoader>
  )

  useEffect(() => {
    const { campaign, secondCampaign } = filters.campaigns

    getCurrentBanner(
      campaign,
      secondCampaign,
      currentBannerList,
      setCurrentBanner,
      setBannerIndex,
      campaignConfigurations,
      getSpecificBannerIndex,
      getRandomBannerIndex
    )
    // eslint-disable-next-line
  }, [filters.campaigns, currentBannerList])

  const setCampaignByBanner = nameCampaign => {
    setCurrentBanner(currentBannerList, true, nameCampaign)
    navigate(link)
  }

  return (
    <>
      {!!banners.length && (
        <>
          {bannerVisible && shouldDisplay ? (
            <>
              <div
                role="button"
                className={styles.imageClear}
                onClick={() => setCampaignByBanner(campaignName)}
                onKeyPress={() => {}}
              >
                <Image
                  source={sourceNormal}
                  sourceMobile={sourceMobile}
                  sourceLarge={sourceLarge}
                  sourceXLarge={sourceXLarge}
                  alt="Banner"
                />
                {displayCountdownFirst &&
                  campaignName &&
                  campaignConfigurations(campaignName).countDown && (
                    <span className={styles.countDown}>
                      <CountDown endDate={timerFirstCampaign()} />
                    </span>
                  )}
                {displayCountdownSecond &&
                  campaignName &&
                  campaignConfigurations(campaignName).countDown && (
                    <span className={styles.countDown}>
                      <CountDown endDate={timerSecondCampaign()} />
                    </span>
                  )}
              </div>
            </>
          ) : (
            shouldDisplay && <Placeholder />
          )}
        </>
      )}
    </>
  )
}

ListBanner.propTypes = {
  filters: PropTypes.shape(),
}

ListBanner.defaultProps = {
  filters: null,
}

export default React.memo(ListBanner)
